
import {
  requestIdleCallback,
} from "plugins/request-animation-frame-polyfill"

const onLoad = (): void => {
  requestIdleCallback(() => {
    Promise.resolve(
      import("./save-search-button/index")
    )
    .then(({default: SaveSearchButton}) => {
      SaveSearchButton.init()
    })
  })
}

export default {onLoad}
